import { render, staticRenderFns } from "./ViewAdmin.vue?vue&type=template&id=2fe5a709&scoped=true&"
import script from "./ViewAdmin.vue?vue&type=script&lang=js&"
export * from "./ViewAdmin.vue?vue&type=script&lang=js&"
import style0 from "./ViewAdmin.vue?vue&type=style&index=0&id=2fe5a709&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe5a709",
  null
  
)

export default component.exports